/**
 * M10 — Crisp support chat beágyazás
 * VITE_CRISP_WEBSITE_ID env változó szükséges. Ha nincs beállítva, nem tölt be semmit.
 */
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

declare global {
  interface Window {
    $crisp: unknown[];
    CRISP_WEBSITE_ID: string;
  }
}

export default function CrispChat() {
  const { user } = useAuth();
  const websiteId = import.meta.env.VITE_CRISP_WEBSITE_ID as string | undefined;

  useEffect(() => {
    if (!websiteId) return;

    window.$crisp = [];
    window.CRISP_WEBSITE_ID = websiteId;

    const script = document.createElement('script');
    script.src = 'https://client.crisp.chat/l.js';
    script.async = true;
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [websiteId]);

  // Crisp user azonosítás — bejelentkezett felhasználó alapján
  useEffect(() => {
    if (!websiteId || !user || !window.$crisp) return;
    window.$crisp.push(['set', 'user:email', [user.email]]);
    window.$crisp.push(['set', 'user:nickname', [user.name]]);
    if (user.companyName) {
      window.$crisp.push(['set', 'user:company', [user.companyName]]);
    }
  }, [websiteId, user]);

  return null;
}
